import { gql } from '@apollo/client';

export const GET_WORKSPACE_DETAIL = gql`
  query GetWorkspaceDetail($id: ID!) {
    workspace: getWorkspaceDetail(id: $id) {
      id
      type
      name
      version
      published
      records
      form {
        id
        name
        webCollection
        submissionsPerPeriod
        url
        published
        # submissions {
        #   id
        #   createdAt
        #   statusDate
        #   status
        #   respondent {
        #     id
        #     firstName
        #     lastName
        #   }
        #   userRespondent {
        #     id
        #     lastName
        #     firstName
        #   }
        #   data {
        #     id
        #     answer
        #     question {
        #       id
        #       name
        #     }
        #   }
        # }
        template {
          id
          updatedAt
          jsonData
        }
        users {
          id
          user {
            id
            firstName
            lastName
          }
          organisation {
            id
            isFunder
            isServiceProvider
            isInstitution
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          formRole {
            id
            name
          }
        }
        respondents {
          id
          user {
            id
            firstName
            lastName
            institutions {
              id
              name
            }
            cohorts {
              id
              name
            }
          }
        }
        dueDates {
          id
          date
          periodDate
        }
      }
      dataset {
        id
        description
        lastSubmitted
        type
        status
        csvFile {
          id
          name
          rowCount
        }
      }
    }
  }
`;
